import { render, staticRenderFns } from "./frozenGoods.vue?vue&type=template&id=6e05e670&scoped=true&"
import script from "./frozenGoods.vue?vue&type=script&lang=js&"
export * from "./frozenGoods.vue?vue&type=script&lang=js&"
import style0 from "./frozenGoods.vue?vue&type=style&index=0&id=6e05e670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e05e670",
  null
  
)

export default component.exports